export enum ApiResponseStatus {
  OK = 'OK',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  OTHER = 'OTHER'
}

export interface ApiResponse<ResultType = any> {
  status: ApiResponseStatus;
  message: string;
  result: ResultType;
}
